module.exports = __webpack_public_path__ + "static/media/banner-harineratlanepantla.9e1ee8e1.jpg";